import React from 'react';
import {makeStyles} from "@material-ui/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardHeader from "@material-ui/core/CardHeader";

const useStyles = makeStyles({
  card: {
    marginTop: '16px'
  },
  media: {
    height: '140px',
  },
});

const ConnectionCard = (props) => {
  const classes = useStyles();
  // const { user } = props;

  return (
    <Card className={classes.card} style={{ marginBottom: '15px', backgroundColor: 'rgb(249, 249, 249)', minHeight: "125px"}}>
      <CardActionArea>
      <CardHeader
        title={props.connection.physicalIssue}
      />
        <CardContent>
          <Typography variant="body1" color="textSecondary" component="p">
            <span dangerouslySetInnerHTML={{__html: props.connection.emotionalLink}} />
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ConnectionCard;